import { render, staticRenderFns } from "./menu-categories.vue?vue&type=template&id=810d7ea4&scoped=true&"
import script from "./menu-categories.vue?vue&type=script&lang=js&"
export * from "./menu-categories.vue?vue&type=script&lang=js&"
import style0 from "./menu-categories.vue?vue&type=style&index=0&id=810d7ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810d7ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/docker-clinica-vitoria/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810d7ea4')) {
      api.createRecord('810d7ea4', component.options)
    } else {
      api.reload('810d7ea4', component.options)
    }
    module.hot.accept("./menu-categories.vue?vue&type=template&id=810d7ea4&scoped=true&", function () {
      api.rerender('810d7ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wordpress/wp-content/themes/astra-child/src/js/components/menu-categories.vue"
export default component.exports